import { RegisterWS } from "@app/core/user/data/network/register.ws";
import { NewUserData } from "@app/core/user/domain/new-user";
import { LoginResponse } from "@app/core/user/domain/login.reponse";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { CompleteProfileWS } from "@app/core/user/data/network/complete-profile.ws";
import { User } from "@app/core/user/domain/user";
import { GetUserProfileWS } from "@app/core/user/data/network/get-user-profile.ws";
import { EditUserProfileWS } from "@app/core/user/data/network/edit-user-profile.ws";
import { DeleteUserWS } from "@app/core/user/data/network/delete-user.ws";
import { UserRepo } from "@app/core/user/domain/repositories/user.repo";
import { GetUserConfigurationWS } from "@app/core/user/data/network/get-user-configuration.ws";
import { PostUserConfigurationWS } from "@app/core/user/data/network/post-user-configuration.ws";

/**
 * User repository implementation.
 */
@Injectable()
export class UserDataRepo implements UserRepo {
  constructor(
    private registerWS: RegisterWS,
    private completeProfileWS: CompleteProfileWS,
    private getUserProfileWS: GetUserProfileWS,
    private editProfileWS: EditUserProfileWS,
    private deleteUserWS: DeleteUserWS,
    private getUserConfigurationWS: GetUserConfigurationWS,
    private postUserConfigurationWS: PostUserConfigurationWS
  ) {}

  /**
   * Register a new user and return the token and if it needs to complete the profile.
   * @param newUserData The new user data.
   */
  register(newUserData: NewUserData): Observable<LoginResponse> {
    return this.registerWS.execute(newUserData);
  }

  /**
   * Complete the user profile.
   * @param params The user profile and the token.
   */
  completeProfile(params: { profile: User; token: string }): Observable<void> {
    return this.completeProfileWS.execute({
      profile: params.profile,
      token: params.token,
    });
  }

  /**
   * Get the user profile.
   * @param token The token of the user.
   */
  get(token: string): Observable<User> {
    return this.getUserProfileWS.execute(token);
  }

  /**
   * Edit the user profile.
   * @param params The new edited user profile and the token.
   */
  edit(params: { profile: User; token: string }): Observable<User> {
    return this.editProfileWS.execute({
      profile: params.profile,
      token: params.token,
    });
  }

  /**
   * Delete the user profile.
   * @param token The token of the user.
   */
  delete(token: string): Observable<void> {
    return this.deleteUserWS.execute(token);
  }
}
